import ReactDOM from "react-dom/client";
import Ceres from "./Ceres.tsx";
// import Ceres from "./Test.tsx";


ReactDOM.createRoot(document.getElementById("root")).render(<Ceres />);